import { isEmpty, isNil } from 'lodash'
import { JobScopeChangeStatus } from '@taxfyle/api-internal/internal/job_scope_change_pb'

export enum JobScopeChangeStatusFilterOption {
  PendingReview,
  Accepted,
  Rejected,
}

export function matchesJobScopeChangeStatusFilter(
  jobScopeChangeStatus: JobScopeChangeStatus,
  jobScopeChangeStatusFilters?: JobScopeChangeStatusFilterOption[],
) {
  if (
    isNil(jobScopeChangeStatusFilters) ||
    isEmpty(jobScopeChangeStatusFilters)
  ) {
    return true
  }

  return jobScopeChangeStatusFilters.some((filter) =>
    isJobScopeChangeStatusMatch(jobScopeChangeStatus, filter),
  )
}

function isJobScopeChangeStatusMatch(
  jobScopeChangeStatus: JobScopeChangeStatus,
  jobScopeChangeStatusFilters: JobScopeChangeStatusFilterOption,
): boolean {
  switch (jobScopeChangeStatusFilters) {
    case JobScopeChangeStatusFilterOption.Accepted:
      return jobScopeChangeStatus === JobScopeChangeStatus.ACCEPTED
    case JobScopeChangeStatusFilterOption.Rejected:
      return (
        jobScopeChangeStatus === JobScopeChangeStatus.REJECTED ||
        jobScopeChangeStatus === JobScopeChangeStatus.APPLY_FAILED
      )
    case JobScopeChangeStatusFilterOption.PendingReview:
      return (
        jobScopeChangeStatus === JobScopeChangeStatus.PENDING_FINALIZATION ||
        jobScopeChangeStatus === JobScopeChangeStatus.PENDING_ADMIN_APPROVAL ||
        jobScopeChangeStatus === JobScopeChangeStatus.PENDING_CLIENT_APPROVAL
      )
    default:
      return false
  }
}
